import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const HypertensionIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M6.6 17.4v2.2h3.6v3.2h3.6v-3.2h3.6v-2.2c-3.3 1.8-7.4 1.8-10.8 0z" />
      <path d="M12 1.2C7.7 1.2 4.2 4.7 4.2 9s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8zm-.2 8.7c-.8 0-1.4-.6-1.4-1.4 0-.2.1-.4.2-.6L9.5 4.5c-.1-.3.1-.6.4-.6.2 0 .4.1.6.2l1.6 3.1c.6.1 1.1.7 1.1 1.3 0 .8-.6 1.4-1.4 1.4z" />
    </IconBase>
  );
};

export default HypertensionIcon;
